import { Drawer } from 'antd';
import './DrawerCart.scss';
import ButtonIconOutlineMedium from '../../../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import { Icon } from '../../../../components/icon/icon';
import { openDrawer } from '../../../../components/common/Drawer/openDrawer';
import i18n from '../../../../languages/i18n';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCart, removeCart } from '../../../../store/actions/room.action';
import { useTranslation } from 'react-i18next';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import Tag from '../../../../components/common/Tag/Tag';
import { Divider } from 'antd';
import DrawerDetailModule from '../DrawerDetailModule/DrawerDetailModule';
import { cn } from '../../../../utils/string/cn.utils';
import ROUTER from '../../../../routers/Routers';
import { Empty } from 'antd';
import ButtonSecondaryLarge from '../../../../components/common/ButtonSecondary/ButtonSecondaryLarge';
import ButtonPrimaryLarge from '../../../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import { openMessageSuccess } from '../../../../components/common/Message/openMessageSuccess';
import { Spin } from 'antd';
import { roundTo } from '../../../../utils/geometry/epsilon';
import { useDeviceType } from '../../../../hooks/useDeviceType';
import { convertForeignCurrency } from '../../../../utils/currency/currency.utils';

const useDrawerCard = () => {
  const modal = useRef(null);
  const device = useDeviceType();

  const openDrawerCart = useCallback(
    config => {
      modal.current = openDrawer({
        title: (
          <>
            <span className="text-title-large-emphasized">
              {i18n.t('Cart')}
            </span>
            <ButtonIconOutlineMedium
              icon={<Icon.ICClose />}
              onClick={() => {
                modal.current?.destroy?.();
                modal.current = null;
                config?.onClose?.();
              }}
            />
          </>
        ),
        closable: false,
        placement: device === 'desktop' ? 'right' : 'bottom',
        classNames: {
          wrapper:
            'shadow-none lg:!w-[800px] !w-full lg:!h-full md:!h-[800px] !h-[690px]',
          body: 'lg:!p-24 md:!px-20 p-16 bg-backgrounds-virtual',
          header:
            'lg:!p-24 md:!px-20 !p-16 [&_.ant-drawer-title]:gap-16 [&_.ant-drawer-title]:items-center [&_.ant-drawer-title]:justify-between [&_.ant-drawer-title]:lg:justify-end [&_.ant-drawer-title]:flex [&_.ant-drawer-title]:lg:flex-row-reverse',
          content:
            'lg:!rounded-l-[16px] lg:!rounded-r-[0px] sm:!rounded-t-[16px] !bg-fills-white',
          footer: '!p-0',
        },
        onClose: () => {
          modal.current?.destroy?.();
          modal.current = null;
          config?.onClose?.();
        },
        content: (
          <>
            <ContentDrawerCart onClose={config?.onClose} />
          </>
        ),
        footer: (
          <>
            <div className="flex lg:p-24 p-16 items-start gap-10 self-stretch justify-between">
              <span className="label-large !font-semibold text-black-medium">
                {i18n.t('Total')}
              </span>
              <span className="text-title-medium">
                <ContentDrawerCartTotal />
              </span>
            </div>
            <ContentDrawerFooter config={config} modal={modal} />
          </>
        ),
        ...config,
      });
    },
    [device]
  );

  return { openDrawerCart };
};

export default useDrawerCard;

// export const openDrawerCart = config => {
//   const drawer = openDrawer({
//     width: 800,
//     title: <span className="text-title-large">{i18n.t('Cart')}</span>,
//     closable: true,
//     classNames: {
//       root: 'rounded-l-[16px]',
//       body: 'p-24 bg-backgrounds-virtual',
//       header:
//         '[&_.ant-drawer-title]:flex p-24 [&_.ant-drawer-title]:items-center [&_.ant-drawer-title]:justify-start [&_.ant-drawer-title]:gap-[24px]',
//       content: 'rounded-l-[16px]',
//     },
//     onClose: config?.onClose,
//     content: (
//       <>
//         <ContentDrawerCart
//           navigate={config?.navigate}
//           onClose={config?.onClose}
//         />
//       </>
//     ),
//     footer: (
//       <>
//         <div className="flex p-24 items-start gap-10 self-stretch justify-between">
//           <span className="text-title-medium">{i18n.t('Total')}</span>
//           <span className="text-title-medium">
//             <ContentDrawerCartTotal />
//           </span>
//         </div>
//         <ContentDrawerFooter config={config} />
//       </>
//     ),
//     ...config,
//   });
//   return drawer;
// };

const ContentDrawerFooter = ({ config, modal }) => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { cart } = useSelector(state => state.room);

  useEffect(() => {
    dispatch(fetchCart({ countryCode: country_code }));
  }, []);

  return (
    <div className="flex lg:p-24 p-16 pb-32 justify-end items-center gap-16 self-stretch border-t-[1px] border-solid border-[#E0E0E0]">
      <ButtonSecondaryLarge
        title={t('Continue shopping')}
        onClick={() => {
          modal.current?.destroy?.();
          config?.onClose?.();
        }}
        className="w-full"
      />
      <ButtonPrimaryLarge
        title={
          t('Go to Cart') +
          ' (' +
          (cart.data?.cart_items?.filter(item => item)?.length ?? 0) +
          ')'
        }
        className="w-full"
        onClick={() => {
          modal.current?.destroy?.();
          config?.onClose?.();
          window.location.href = ROUTER.CART;
        }}
      />
    </div>
  );
};

const ContentDrawerCartTotal = () => {
  const { cart } = useSelector(state => state.room);
  // const [totalPrice, setTotalPrice] = useState({
  //   totalWoodPrice: 0,
  //   totalStoneAndGlassPrice: 0,
  //   totalAccessoryPrice: 0,
  //   totalCouponPrice: 0,
  //   total: 0,
  //   subtotal: 0,
  // });

  // useEffect(() => {
  //   // const total = {
  //   //   ...totalPrice,
  //   //   totalWoodPrice: 0,
  //   //   totalStoneAndGlassPrice: 0,
  //   //   totalAccessoryPrice: 0,
  //   //   subtotal: 0,
  //   // };
  //   // if (cart.data?.cart_items?.length) {
  //   //   cart.data.cart_items.forEach(item => {
  //   //     total.totalWoodPrice += item.total_wood_price ?? 0;
  //   //     total.totalAccessoryPrice += item.total_accessory_price ?? 0;
  //   //     total.totalStoneAndGlassPrice +=
  //   //       (item.total_countertop_price ?? 0) +
  //   //       (item.total_backsplash_price ?? 0);
  //   //     if (Number(item.price_after)) {
  //   //       total.subtotal += Number(item.price_after);
  //   //     } else {
  //   //       total.subtotal +=
  //   //         (item.total_wood_price ?? 0) +
  //   //         (item.total_accessory_price ?? 0) +
  //   //         (item.total_countertop_price ?? 0) +
  //   //         (item.total_backsplash_price ?? 0);
  //   //     }
  //   //   });
  //   //   total.total = total.subtotal - total.totalCouponPrice;
  //   // }
  //   // setTotalPrice(total);
  // }, [cart.data?.cart_items]);

  return (
    <>
      {convertForeignCurrency(
        (cart.data?.total_amount ?? 0) - cart.data?.shipping_fee
      )}
    </>
  );
};

const ContentDrawerCart = ({ onClose }) => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const { t } = useTranslation();

  const [moduleId, setModuleId] = useState(null);
  const { cart } = useSelector(state => state.room);
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  const renderCartItem = item => {
    return (
      <CardDetailModule
        title={getValueFromString(item.product_name)}
        icon={item.thumbnail}
        content={
          <>
            <div className="flex flex-col items-start self-stretch gap-[12px]">
              <div className="flex items-start justify-start gap-[8px] flex-col self-stretch">
                <div className="lg:flex hidden items-center self-stretch h-[24px] gap-[40px] text-body-medium justify-between">
                  <span className="truncate text-body-medium text-black/60 ">
                    {t('Product name')}
                  </span>
                  <span
                    className="truncate max-w-[350px] font-semibold"
                    title={getValueFromString(item.item_name)}
                  >
                    {getValueFromString(item.item_name)}
                  </span>
                </div>
                {item.size ? (
                  <div className="flex items-center self-stretch gap-[40px] text-body-medium justify-between">
                    <span className="truncate text-body-medium text-black/60 ">
                      {t('Size')}
                    </span>
                    <div>
                      {(() => {
                        if (typeof item.size === 'string') {
                          return (
                            <span className="font-semibold text-black/80 self-stretch">
                              {item.size}
                            </span>
                          );
                        } else {
                          return (
                            <span className="font-semibold text-black/80 self-stretch">
                              {`${roundTo(item.size.depth, 0)}x${roundTo(
                                item.size.height,
                                0
                              )}x${roundTo(item.size.length, 0)} mm`}
                            </span>
                          );
                        }
                      })()}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>

              {item.total_wood_price ||
              item.total_accessory_price ||
              item.total_backsplash_price ||
              item.total_countertop_price ? (
                <Divider type="horizontal" className="!p-0 m-0" />
              ) : null}

              <div className="flex items-start justify-start gap-[8px] flex-col self-stretch">
                {item.total_wood_price ? (
                  <div className="flex items-center self-stretch h-[24px] gap-[40px] text-body-medium justify-between">
                    <span className="truncate text-body-medium text-black/60 ">
                      {t('Total wood price')}
                    </span>
                    <span className="truncate font-semibold text-black/80 self-stretch">
                      {convertForeignCurrency(item.total_wood_price)}
                    </span>
                  </div>
                ) : (
                  <></>
                )}

                {item.total_accessory_price ? (
                  <div className="flex items-center self-stretch h-[24px] gap-[40px] text-body-medium justify-between">
                    <span className="truncate text-body-medium text-black/60 ">
                      {t('Total accessory price')}
                    </span>
                    <span className="truncate font-semibold text-black/80 self-stretch">
                      {convertForeignCurrency(item.total_accessory_price)}
                    </span>
                  </div>
                ) : (
                  <></>
                )}
                {item.total_countertop_price ? (
                  <div className="flex items-center self-stretch h-[24px] gap-[40px] text-body-medium justify-between">
                    <span className="truncate text-body-medium text-black/60 ">
                      {t('Total countertop price')}
                    </span>
                    <span className="truncate font-semibold text-black/80 self-stretch">
                      {convertForeignCurrency(item.total_countertop_price)}
                    </span>
                  </div>
                ) : (
                  <></>
                )}

                {item.total_backsplash_price ? (
                  <div className="flex items-center self-stretch h-[24px] gap-[40px] text-body-medium justify-between">
                    <span className="truncate text-body-medium text-black/60 ">
                      {t('Total backsplash price')}
                    </span>
                    <span className="truncate font-semibold text-black/80 self-stretch">
                      {convertForeignCurrency(item.total_backsplash_price)}
                    </span>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <Divider type="horizontal" className="!p-0 m-0" />
            <div className="flex lg:items-center items-start gap-[40px] text-body-medium font-semibold self-stretch justify-between">
              <span className="truncate text-body-large font-semibold text-black/80 ">
                {t('Total price')}
              </span>
              <div className="flex lg:flex-row flex-col lg:items-center items-start justify-end lg:gap-16 gap-[4px]">
                {item.discount_value && item.discount_type ? (
                  <Tag
                    label={
                      <div className="flex items-center justify-center gap-[4px]">
                        <span className="flex w-[16px] h-[16px]">
                          <Icon.ICPercentDiscount />
                        </span>
                        <span className="text-label-medium">
                          {t('{{x}}% Off', {
                            x:
                              item.discount_type === 'PERCENT_DISCOUNT'
                                ? `${item.discount_value || 0}`
                                : `${convertForeignCurrency(item.discount_value)}`,
                          })}
                        </span>
                      </div>
                    }
                    className="py-[4px] px-[8px] rounded-[4px] bg-Accents-Red-Fill-Varient text-Accents-On-Red-Fill"
                  />
                ) : null}

                <div className="flex lg:gap-[8px] gap-[4px] justify-center lg:items-center lg:flex-row flex-col items-end">
                  <span className="text-body-small line-through text-black-medium">
                    {(() => {
                      if (
                        Number(item.price_after) !== Number(item.price_original)
                      ) {
                        return convertForeignCurrency(
                          Number(item.price_original)
                        );
                      }
                    })()}
                  </span>
                  <span
                    className={cn(
                      'truncate text-body-large font-semibold self-stretch',
                      Number(item.price_after) !== Number(item.price_original)
                        ? 'text-Accents-Red'
                        : 'text-black'
                    )}
                  >
                    {convertForeignCurrency(
                      (() => {
                        if (Number(item.price_after)) {
                          return Number(item.price_after);
                        } else {
                          return (
                            (item.total_wood_price ?? 0) +
                            (item.total_accessory_price ?? 0) +
                            (item.total_countertop_price ?? 0) +
                            (item.total_backsplash_price ?? 0)
                          );
                        }
                      })()
                    )}
                  </span>
                </div>
              </div>
            </div>
          </>
        }
        actions={
          <>
            {['design'].some(i => item.sale_type?.includes(i)) ? (
              <>
                <ButtonIconOutlineMedium
                  icon={<Icon.ICEdit className={'opacity-60'} />}
                  onClick={() => {
                    try {
                      if (item.is_library) {
                        window.location.href =
                          ROUTER.DESIGN +
                          '/' +
                          item.type_design +
                          `?sale_product=${item.design_id}`;
                      } else {
                        window.location.href =
                          ROUTER.DESIGN +
                          '/' +
                          item.type_design +
                          `?design_id=${item.design_id}`;
                      }
                      onClose?.();
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                />

                <ButtonIconOutlineMedium
                  icon={<Icon.ICAssignmentList className={'opacity-60'} />}
                  onClick={() => setModuleId(item.id)}
                />
              </>
            ) : (
              <></>
            )}

            <ButtonIconOutlineMedium
              icon={<Icon.ICDelete className={'opacity-60'} />}
              onClick={() => {
                dispatch(removeCart({ cartId: item.id })).then(action => {
                  if (action.payload) {
                    openMessageSuccess({ content: t('Successfully') });
                  }
                });
              }}
            />
          </>
        }
      />
    );
  };
  useEffect(() => {
    if (cart.isNeedReloadData) {
      dispatch(fetchCart({ countryCode: country_code }));
    }
  }, [cart.isNeedReloadData]);

  return (
    <>
      {cart.isLoading ? (
        <div className="flex items-center justify-center self-stretch grow">
          <Spin spinning size="medium" />
        </div>
      ) : cart.data?.cart_items?.length ? (
        <>
          <div className="flex flex-col items-start gap-16 grow self-stretch">
            {cart.data?.cart_items
              ?.filter(item => item)
              ?.map(item => {
                return <>{renderCartItem(item)}</>;
              })}
          </div>
        </>
      ) : (
        <div className="flex self-stretch grow items-center justify-center">
          <Empty description={false} />
        </div>
      )}

      <DrawerDetailModule
        open={moduleId}
        items={
          cart.data?.cart_items?.find(item => item.id === moduleId)?.data ??
          '[]'
        }
        imageList={(() => {
          const item = cart.data?.cart_items?.find(
            item => item.id === moduleId
          );
          return item ? [item.thumbnail, item.image] : [];
        })()}
        onClose={() => setModuleId(null)}
      />
    </>
  );
};

const CardDetailModule = ({
  title,
  content,
  icon,
  actions,
  classNames = { root: '', icon: '', actionsContainer: '' },
}) => {
  return (
    <div
      className={cn(
        'flex items-center self-stretch flex-shrink rounded-[16px] bg-fills-white shadow-dropshadow2',
        classNames.root
      )}
    >
      <div className="flex lg:p-[40px] p-16 items-start gap-[8px] self-stretch">
        <div
          style={{ backgroundImage: `url(${icon})` }}
          alt={title}
          className={cn(
            'lg:w-[120px] lg:h-[120px] w-[80px] h-[80px] rounded-[2px] bg-[lightgray] bg-center bg-cover bg-no-repeat aspect-square',
            classNames.icon
          )}
        ></div>
      </div>
      <div className="flex lg:p-[40px] p-16 ps-0 flex-col items-start gap-[12px] grow self-stretch">
        <div className="flex content-center items-center gap-[8px] self-stretch">
          <span className="text-title-medium line-clamp-1 grow truncate">
            {title}
          </span>
          <div
            className={cn(
              'flex content-center items-center self-stretch gap-[8px]',
              classNames.actionsContainer
            )}
          >
            {actions}
          </div>
        </div>
        <div className="flex flex-col items-start gap-[12px] self-stretch grow">
          {content}
        </div>
      </div>
    </div>
  );
};
